/**
 * The colours used to accent the UI.
 */
export const ACCENT_COLOR = {
  main: {
    hue: 280,
    saturation: 14,
    lightness: 81,
  },
  darker: {
    hue: 280,
    saturation: 13,
    lightness: 22,
  },
  contrastText: {
    hue: 280,
    saturation: 13,
    lightness: 19,
  },
  background: {
    hue: 280,
    saturation: 10,
    lightness: 81,
  },
  backgroundContrastText: {
    hue: 280,
    saturation: 4,
    lightness: 29,
  },
};
